import styled from 'styled-components';

type StyledGapContainerProps = {
  gap: number;
};
export const StyledGapContainer = styled.div<StyledGapContainerProps>`
  display: flex;
  flex-direction: column;
  gap: ${({ gap }) => `${gap}px`};
`;
